import React, { Component } from "react";
import { List } from "semantic-ui-react";
import { connect } from "react-redux";
import { selectedPatient } from "../../../actions/auth";

export class PatientItem extends Component {
  render() {
    return (
      <List.Item
        as="a"
        className="listItemPadding"
        onClick={() => {
          this.props.selectedPatient({
            patient_id: this.props.patient.cedula,
            fullname: this.props.patient.paciente
          });
          this.props.showPatientOrdersList({
            patient_id: this.props.patient.cedula,
            fullname: this.props.patient.paciente,
            practitioner: this.props.practitioner,
            startDate: this.props.filterRange?.startDate || null,
            endDate: this.props.filterRange?.endDate || null,
            search: this.props.filterRange?.text || null
          });
        }}
      >
        <List.Content>
          <List.Header>{this.props.patient.paciente}</List.Header>
          <List.Content>
            Identificación: {this.props.patient.cedula} 
            {this.props.patient.no_historia !== ""
              ? ` | Historía:${this.props.patient.no_historia}`
              : ""}
          </List.Content>
        </List.Content>
      </List.Item>
    );
  }
}

const mapStateToProps = (state) => ({
  filterRange: state.patientOrderResults.filterRange
});

export default connect(null, { selectedPatient })(PatientItem);
